module.exports = __webpack_public_path__ + "img/NewDragCartIcon.6806d656.svg";